export async function testApi() {
  const url = import.meta.env.VITE_SERVER_URL + "/api/test/ping";
  let startTime, endTime;
  try {
    startTime = performance.now();
    const response = await fetch(url);
    endTime = performance.now();
    if (!response.ok) return null;
    const data = await response.json();
    if (data.ping === "pong") return { ping: endTime - startTime, version: data.version }; // Return the time taken in milliseconds
    return null;
  } catch (error) {
    console.error("Fetch error:", error);
    return null;
  }
}
export async function testSql() {
  const url = import.meta.env.VITE_SERVER_URL + "/api/test/sql";
  let startTime, endTime;
  try {
    startTime = performance.now();
    const response = await fetch(url);
    endTime = performance.now();
    if (!response.ok) {
      console.log("Sql response not ok");
      return null;
    }
    const data = await response.json();
    if (data[0].Greeting === "Hello World") return endTime - startTime; // Return the time taken in milliseconds
    return null;
  } catch {
    return null;
  }
}
